import OpInput from "./index.vue";
var opinput = {
  install: function install(Vue) {
    Vue.component("OpInput", OpInput);
  }
};
export default opinput;